"use client";

import { MONTHS } from "./constants";

export default function ControlStrip({ state }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 mb-6 flex flex-col md:flex-row justify-between gap-3 items-stretch md:items-center print:hidden">
      <div className="flex gap-3 flex-wrap items-center">
        <label className="flex items-center gap-2 text-slate-600 text-sm font-medium">
          Month
          <select
            value={state.month}
            onChange={(e) => state.setMonth(e.target.value)}
            className="border border-slate-200 rounded-lg bg-white px-3 py-2 text-sm text-slate-700 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 outline-none"
          >
            {MONTHS.map((m) => (
              <option key={m}>{m}</option>
            ))}
          </select>
        </label>

        <label className="flex items-center gap-2 text-slate-600 text-sm font-medium">
          View
          <select
            value={state.viewMode}
            onChange={(e) => state.setViewMode(e.target.value)}
            className="border border-slate-200 rounded-lg bg-white px-3 py-2 text-sm text-slate-700 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 outline-none"
          >
            <option value="monthly">Monthly</option>
            <option value="annual">Annual</option>
          </select>
        </label>

        <label className="flex items-center gap-2 text-slate-600 text-sm font-medium">
          Annual fees
          <select
            value={state.annualMode}
            onChange={(e) => state.setAnnualMode(e.target.value)}
            className="border border-slate-200 rounded-lg bg-white px-3 py-2 text-sm text-slate-700 focus:ring-2 focus:ring-slate-400 focus:border-slate-400 outline-none"
          >
            <option value="spread">Divide in 12 Months</option>
            <option value="selectedMonth">Collect in Selected Month</option>
            <option value="ignoreMonthly">Do Not Add in Monthly</option>
          </select>
        </label>
      </div>

    </div>
  );
}
